import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2d23e544")

_pushScopeId("data-v-2d23e544")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "align-center" }, [
  /*#__PURE__*/_createVNode("img", { src: "https://lh3.googleusercontent.com/d/10_jbfOvX03C0KGM5Iksixo8Ffyn4V4Hv" })
], -1)
const _hoisted_2 = { class: "container align-center" }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "title is-3" }, "HOUSTON WE HAVE A PROBLEM...", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { style: {"font-size":"30px"} }, "We can't seem to find what you're looking for", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("p", { class: "title is-3" }, "GO BACK HOME", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createVNode("a", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.route('/')))
      }, [
        _hoisted_6
      ])
    ])
  ], 64))
})